import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/src/userSegRedirectEntrypoint.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { listEntryPoint } from '@jira/spa-apps__business-list/src/listEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';

import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessListRoute } from '@jira/router-routes__business-list-routes/src/jiraBusinessListRoute.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { ProjectIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { getRouteReporting } from '@jira/router-routes__issue-navigator-entries/src/common/getRouteReporting.tsx';
import { issueNavigatorPageEntryPoint } from '@jira/router-routes__issue-navigator-entries/src/ui/index.tsx';
import { getCommonProjectResources } from '@jira/router-routes__issue-navigator-entries/src/common/getCommonProjectResources.tsx';
import { getSsrCircuitBreaker } from '@jira/router-routes__issue-navigator-entries/src/common/getSsrCircuitBreaker.tsx';
import { adjustSsrFetchTimeout } from '@jira/router-routes__issue-navigator-entries/src/common/getSsrFetchTimeout.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const listPageEntryPoint = createPageEntryPoint({
	main: listEntryPoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
	redirect: userSegRedirectEntrypoint,
});

export const jiraBusinessListRouteEntry: Route = createEntry(jiraBusinessListRoute, () => ({
	group: 'classic-business',
	ufoName: fg('jira_list_nin_merge') ? 'jwm-list-nin' : 'jwm.list-view',
	meta: fg('jira_list_nin_merge')
		? {
				capability: NIN_NEW_ISSUE_NAVIGATOR,
				reporting: getRouteReporting(),
			}
		: undefined,
	layout: businessProjectLayout,
	skeleton: fg('jira_list_nin_merge') ? ProjectIssueNavigatorSkeleton : ThemedLazySkeleton,
	entryPoint: () => (fg('jira_list_nin_merge') ? issueNavigatorPageEntryPoint : listPageEntryPoint),
	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},
	resources: fg('jira_list_nin_merge') ? getCommonProjectResources() : getProjectViewResources(),
	bifrost: {
		bifrostGroup: 'issue-navigator',
		manifestName: 'jira-spa-issue-navigator.json',
		circuitBreakerConfig: fg('jira_list_nin_merge') ? getSsrCircuitBreaker() : undefined,
		// Experiment to test the impact of increasing the resource timeout for issue navigator routes
		fetchTimeout: adjustSsrFetchTimeout(expVal('nin_ssr_resource_timeout', 'timeout', 0)),
	},
	supportsPreviewPanel: true,
	// Pre-merge (jira_list_nin_merge off) the JWM list view is already fully themed, so keep
	// 'full' to avoid regressing those customers; post-merge, respect the theming experiment.
	supportsProjectTheme:
		!fg('jira_list_nin_merge') || expVal('jira-list-full-theming-exp', 'isEnabled', false)
			? 'full'
			: 'contoured',
	isHydrateRootEnabled: fg('jira_list_nin_merge'),
	excludeFromWrmDeferredLoading: fg('jira_list_nin_merge'),
}));
